import { gql } from "@apollo/client";

const CREATE_HEI_CONNECTION = gql`
  mutation createHEIConnection($backendInstanceId: Int, $dashboardHeiId: String, $schacCode: String)
    {createHEIConnection(backendInstanceId: $backendInstanceId, dashboardHeiId: $dashboardHeiId, schacCode: $schacCode) {
      id
      label
      heiId
      dashboardHeiId
      backendHeiId
      backendInstance
      status
    }  
  }`
;

export default CREATE_HEI_CONNECTION;
